import IncidentReport from "../fragments/incidentReport";

export default `
mutation UpdateIncidentReport($input: IncidentReportInput!) {
  updateIncidentReport(input: $input) ${IncidentReport}
}
`;
